"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackTraceSection = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _UnformattedBlock = require("./UnformattedBlock");
var _jsxRuntime = require("react/jsx-runtime");
const StackTraceSection = ({
  errorStack
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
  mb: 3,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Accordion, {
    disableGutters: true,
    elevation: 2,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AccordionSummary, {
      expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDown, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        gutterBottom: true,
        variant: "subtitle1",
        flexGrow: 1,
        textAlign: "center",
        children: "Stack Trace"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AccordionDetails, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_UnformattedBlock.UnformattedBlock, {
        children: errorStack
      })
    })]
  })
});
exports.StackTraceSection = StackTraceSection;
